export default __webpack_public_path__ + "static/media/WebinarPause.4d1ce5f6.jpg";